export * from './tabs.component';
export * from './tabs.module';
